import React from "react";
import "./index.scss";

import { Tooltip } from "@material-ui/core";
import { Link } from "gatsby";

function ArticleCard({
  miniviewData,
  title = "Article",
  className = "",
  isAllArticles = true,
  isDisableLink = false,
  type = "",
}) {
  return (
    <div className="body-container">
      <div className="feature-card-title">
        <h4>{title}</h4>
      </div>
      <div className={`article-card-body ${className}`}>
        {isAllArticles
          ? miniviewData?.map((item, index) => {
              return (
                <div key={index} className="article-body-card-home">
                  <Link
                    className="article_link_card"
                    target="_blank"
                    to={
                      isDisableLink ? "#" : `/${item.slug_type}/${item.slug}/`
                    }
                  >
                    <div className="article-card-body-container">
                      <div className="article-card-body-img">
                        <img src={item?.og_image} alt={item?.imageAltTxt} />
                      </div>
                      <div className="article-card-body-icon">
                        {item.slug_type != "Client Brief" && (
                          <Link
                            target="_blank"
                            to={
                              isDisableLink
                                ? "#"
                                : `/${item.slug_type}/${item.slug}/`
                            }
                          >
                            <Tooltip title="Preview" placement="bottom">
                              <div className="icon-main preview-icon"></div>
                            </Tooltip>
                          </Link>
                        )}
                      </div>
                    </div>
                    <div className="article-card-body-text">
                      <h4 className="article-card-title-text">{item?.title}</h4>
                      <p className="article-card-description">
                        {item?.og_description}
                      </p>
                    </div>
                  </Link>
                </div>
              );
            })
          : miniviewData?.slice(0, 3)?.map((item, index) => {
              return (
                <div key={index} className="article-body-card-spc">
                  <Link
                    className="article_link_card"
                    target="_blank"
                    to={
                      isDisableLink ? "#" : `/${item.slug_type}/${item.slug}/`
                    }
                  >
                    <div className="article-card-body-container">
                      <div className="article-card-body-img">
                        <img src={item?.og_image} alt={item?.imageAltTxt} />
                      </div>
                      <div className="article-card-body-icon">
                        {item.slug_type != "Client Brief" && (
                          <Link
                            target="_blank"
                            to={
                              isDisableLink
                                ? "#"
                                : `/${item.slug_type}/${item.slug}/`
                            }
                          >
                            <Tooltip title="Preview" placement="bottom">
                              <div className="icon-main preview-icon"></div>
                            </Tooltip>
                          </Link>
                        )}
                      </div>
                    </div>
                    <div className="article-card-body-text">
                      <h4 className="article-card-title-text">{item?.title}</h4>
                      {type !== "related" && (
                        <p className="article-card-description">
                          {item?.og_description}
                        </p>
                      )}
                    </div>
                  </Link>
                </div>
              );
            })}
      </div>
    </div>
  );
}

export default ArticleCard;
